import React from 'react';
import ScrollToTop from '../components/ScrollToTop';
import MessageMe from '../components/MessageMe';
import Footer from '../components/Footer';


const Contact = () => {
    return (
        <>
            <ScrollToTop />
            <MessageMe />
            <Footer />
        </>
    )
}

export default Contact
